import { hasWindow } from "@omni/utils/dom.utils";

import {
    PureAemComponent,
    registerComponent
} from "@/components/pureAemComponent";

class InfoBlock extends PureAemComponent {
    trigger: HTMLAnchorElement | null;
    content: HTMLElement | null;
    isOpened: boolean = false;

    constructor(element: HTMLElement) {
        super(element);
        this.trigger = this.element.querySelector(".js-info-block__trigger");
        this.content = this.element.querySelector(".js-info-block__content");
        this.init();
    }

    /**
     * Initialize the component
     */
    init() {
        this.bindEventListeners();
    }

    /**
     * Bind the event to their handlers
     */
    bindEventListeners() {
        if (this.trigger) {
            this.trigger.addEventListener(
                "click",
                this.clickHandler.bind(this)
            );
        }

        if (this.content) {
            this.content.addEventListener(
                "transitionstart",
                this.disableOverflowAnchor.bind(this)
            );
            this.content.addEventListener(
                "transitionend",
                this.enableOverflowAnchor.bind(this)
            );
            this.content.addEventListener(
                "transitioncancel",
                this.enableOverflowAnchor.bind(this)
            );
        }

        window.addEventListener(
            "infoBlock.opened",
            this.hideContent.bind(this)
        );
    }

    /**
     * Handle the click event of the toggle trigger
     * @param e
     */
    clickHandler(e: Event) {
        e.preventDefault();
        this.toggleContentBlock();
    }

    /**
     * Toggle the content block
     * - show/hide depends of the isOpened state
     */
    toggleContentBlock() {
        if (this.isOpened) {
            this.hideContent();
        } else {
            this.showContent();
        }
    }

    /**
     * Show the content
     * - set the state
     * - set the class
     */
    showContent() {
        // Keep this order
        this.notifyOtherInfoBlocks();
        this.isOpened = true;
        this.element.classList.add("info-block--active");
        this.alignToTop();
    }

    /**
     * Hide the content
     * - set the state
     * - set the class
     */
    hideContent() {
        this.isOpened = false;
        this.element.classList.remove("info-block--active");
    }

    /**
     * Align this element to the top
     */
    alignToTop() {
        this.element.scrollIntoView();
        const y = this.element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
    }

    /**
     * Send an event on the window to notify other infoBlocks to close
     */
    notifyOtherInfoBlocks() {
        window.dispatchEvent(new Event("infoBlock.opened"));
    }

    private disableOverflowAnchor() {
        document.body.classList.add("overflow-anchor-disabled");
    }

    private enableOverflowAnchor() {
        document.body.classList.remove("overflow-anchor-disabled");
    }
}
const InitInfoBlock = () => {
    hasWindow() && registerComponent(".js-info-block", InfoBlock);
};

export { InitInfoBlock };
